import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Subject {
  label: string;
  value: string;
}

interface ProjectState {
  selectedProject: Subject;
}

const initialState: ProjectState = {
  selectedProject: { label: "All Subjects", value: "all-subjects" },
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    setSelectedProject(state, action: PayloadAction<Subject>) {
      state.selectedProject = action.payload;
    },
  },
});

export const { setSelectedProject } = projectSlice.actions;
export default projectSlice.reducer;
